<template>
  <div class="page-bg">
    <div class="container">
        <router-link class="return" to="/welcome"><icon name="arrow-left" scale='2' class='icon'></icon> <span>Home</span></router-link>
        <h2>{{ $i18n.t('FOOTER.PRIVACY-POLICY') }}</h2>
        <div v-html="$store.getters.getData.privacy_policy"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
}
</script>

<style lang="sass" scoped>
.page-bg
  padding-top: 3rem
  background-color: #fff

  .return
    cursor: pointer
    display: flex
    align-items: center

    span
      margin-left: .5rem

  h2
    font-size: 1.6rem
    font-weight: bold

  div
    font-size: 1rem
    color: #221f1f

</style>



// WEBPACK FOOTER //
// src/pages/site/PrivacyPolicy.vue